import {Type} from "class-transformer";
import {UserTagModel} from "./user-tag.model";
import {AlbumModel} from "./album.model";

export class AlbumsByTagModel {
  @Type(() => UserTagModel)
  tag: UserTagModel;
  @Type(() => AlbumModel)
  albums: AlbumModel[];
}
